module.exports = __webpack_public_path__ + "img/image_service_4.9c635380.png";